import Message from "../../message";
import {useMainStore} from "@/store";

export default class InviteReceived extends Message
{
    handle()
    {
        useMainStore().ADD_INVITE(this.message.invite);
    }
}
